import { gql } from '@apollo/client'
import { CORE_OWN_USER_FIELDS } from './ownUser'

export const LOG_IN = gql`
  ${CORE_OWN_USER_FIELDS}
  query Login($email: String!, $password: String!) {
    login(login: { email: $email, password: $password }) {
      id
      refreshId
      expireTime
      user {
        ...OwnUserFields
      }
    }
  }
`

export const REFRESH = gql`
  ${CORE_OWN_USER_FIELDS}
  query Refresh($refreshId: ID!) {
    refresh(refreshId: $refreshId) {
      id
      refreshId
      expireTime
      user {
        ...OwnUserFields
      }
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation ResetPassword($password: String!) {
    resetUserCredentials(newPassword: { newPassword: $password })
  }
`

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`

export const LOGOUT = gql`
  query Logout {
    logout
  }
`

export const PERMISSIONS_DATA = gql`
  query GetPermissions {
    permissions {
      id
      name
      action
      target
      description
      modulator
      is_internal
    }
  }
`

export const LOG_IN_GOOGLE = gql`
  ${CORE_OWN_USER_FIELDS}
  query LoginGoogle($credential: String!) {
    loginGoogle(credential: $credential) {
      id
      refreshId
      expireTime
      user {
        ...OwnUserFields
      }
    }
  }
`

export const SSO_LOGIN_CONFIG = gql`
  query SsoLoginConfig($email: String!) {
    ssoLoginConfig(email: $email) {
      isAvailable
      isRequired
      provider
      ssoClientId
      ssoIssuer
    }
  }
`

export const SSO_LOGIN_CONFIG_FOR_ISSUER = gql`
  query SsoLoginConfigForIssuer($issuer: String!) {
    ssoLoginConfigForIssuer(issuer: $issuer) {
      isAvailable
      isRequired
      provider
      ssoClientId
      ssoIssuer
    }
  }
`

export const LOG_IN_OIDC = gql`
  ${CORE_OWN_USER_FIELDS}
  query LoginOidc(
    $code: String!
    $codeVerifier: String!
    $redirectUri: String!
    $issuer: String!
  ) {
    loginOidc(
      code: $code
      codeVerifier: $codeVerifier
      redirectUri: $redirectUri
      issuer: $issuer
    ) {
      id
      refreshId
      expireTime
      user {
        ...OwnUserFields
      }
    }
  }
`

export const VALIDATE_AUTH_USER_PIN = gql`
  query ValidateAuthUserPin {
    validateAuthUserPin
  }
`

export const INTERCOM_USER_JWT = gql`
  query IntercomUserJwt {
    intercomUserJwt
  }
`
